interface ToolbarProps {
  hidden?: boolean;
  targetUrl?: string;
  children: React.ReactNode;
}

export function Toolbar({ hidden = false, children }: ToolbarProps) {
  return (
    <header
      aria-hidden={hidden}
      className={`fixed top-3 left-3 right-3 z-50 flex items-center rounded-2xl border border-border bg-background/95 px-4 py-1 text-foreground shadow-lg backdrop-blur-sm transition-[transform,opacity] duration-300 ease-out ${
        hidden
          ? '-translate-y-[150%] opacity-0 pointer-events-none'
          : 'translate-y-0 opacity-100'
      }`}
    >
      {children}
    </header>
  );
}
